import React from 'react';

import { Container, Text } from './styles';

const TooltipStatus = ({ children, text, ...otherProps }) => (
  <Container
    {...otherProps}
  >
    <Text>{text}</Text>
    {children}
  </Container>
);

export default TooltipStatus;
